import { createTheme } from '@mui/material/styles';

import T from "./tokens";
const theme = createTheme({
  palette: {
    primary: {
      main: T["--c-brand"],
      light: T["--c-brand"],
      dark: T["--c-brand-hover"],
      contrastText: T["--c-ffffff"]
    },
    secondary: {
      main: T["--c-1a1a1a"],
      light: T["--c-374151"],
      dark: T["--c-111827"],
      contrastText: T["--c-ffffff"]
    },
    success: {
      main: T["--c-brand"],
      light: T["--c-brand"],
      dark: T["--c-brand-hover"]
    },
    warning: {
      main: T["--c-f59e0b"],
      light: T["--c-fbbf24"],
      dark: T["--c-d97706"]
    },
    error: {
      main: T["--c-ef4444"],
      light: T["--c-f87171"],
      dark: T["--c-dc2626"]
    },
    background: {
      default: T["--c-f8f9fa"],
      paper: T["--c-ffffff"]
    },
    text: {
      primary: T["--c-1a1a1a"],
      secondary: T["--c-6b7280"]
    }
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      letterSpacing: '-0.02em'
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 700,
      letterSpacing: '-0.02em'
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 700,
      letterSpacing: '-0.02em'
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 700,
      letterSpacing: '-0.02em'
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600
    }
  },
  shape: {
    borderRadius: 12
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 12
        },
        contained: {
          boxShadow: `0 4px 14px 0 ${T["--brand-a0_3"]}`,
          '&:hover': {
            boxShadow: `0 6px 20px 0 ${T["--brand-a0_4"]}`
          }
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: `0 2px 8px ${T["--rgba-0-0-0-a0_08"]}`,
          borderRadius: 16
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 12,
            '&:hover fieldset': {
              borderColor: T["--c-brand"]
            },
            '&.Mui-focused fieldset': {
              borderColor: T["--c-brand"]
            }
          }
        }
      }
    }
  }
});

export default theme;
